module.exports = __webpack_public_path__ + "static/media/globe.9e3a2bad.svg";